import AdornmentValidator from '../../components/AdornmentValidator';
import { t } from 'i18next';
import React from 'react';

export interface RuleValidationInterface {
  valid: boolean
  adornment: React.ReactNode,
  color: 'success' | 'warning',
  requiredText: string
}

export const useRuleValidation = (validation: () => boolean):RuleValidationInterface => {
  const valid = validation();

  const adornment = <AdornmentValidator checked={valid} />;

  const color = valid ? 'success' : 'warning';

  const requiredText = valid ? '' : ` (${t('requiredField')?.toLowerCase()})`;

  const RuleValidation:RuleValidationInterface = {
    valid,
    adornment,
    color,
    requiredText
  };

  return RuleValidation
};

export default useRuleValidation;
